var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useRef, useEffect } from 'react';
import Button from '@digitools/honest-react/dist/lib/components/Button';
import Modal from '@digitools/honest-react/dist/lib/components/Modal';
import themes from '@digitools/honest-react/dist/lib/theming/themes';
import useTimeout from '../../hooks/useTimeout';
import useAnyAction from '../../hooks/useAnyAction';
import useAuthentication from '../../hooks/useAuthentication';
var TimeoutModal = function (_a) {
  var _b = _a.seconds,
    seconds = _b === void 0 ? 1200 : _b,
    _c = _a.sRemainingForModal,
    sRemainingForModal = _c === void 0 ? 300 : _c;
  var _d = useAuthentication(),
    isAuthenticated = _d.isAuthenticated,
    logout = _d.logout;
  var _e = useTimeout(seconds * 1000, isAuthenticated),
    ready = _e[0],
    sRemaining = _e[1],
    reset = _e[2];
  var isOpenRef = useRef(function () {});
  var showingModal = sRemaining <= sRemainingForModal;
  var setControl = function (setIsOpen) {
    isOpenRef.current = setIsOpen;
  };
  // Don't reset timer if modal is already showing
  useAnyAction(!showingModal && isAuthenticated ? reset : undefined);
  useEffect(function () {
    if (showingModal) {
      isOpenRef.current(true);
    }
  }, [showingModal]);
  // TODO: release render props types from Honest
  var FooterPrimaryButton = /*#__PURE__*/memo(function (_a) {
    var hideModal = _a.hideModal;
    var handleClick = function () {
      reset();
      hideModal();
    };
    return _jsx(Button, __assign({
      "data-testid": 'timeout-continue-button',
      buttonType: 'primary',
      onClick: handleClick
    }, {
      children: "Continue"
    }));
  });
  if (ready) {
    logout({
      inactive: 'true'
    });
  }
  return _jsx(_Fragment, {
    children: showingModal && _jsx(Modal, __assign({
      headerText: 'Are you still there?',
      footerPrimaryRenderButton: FooterPrimaryButton,
      footerContentPosition: 'flex-start',
      getControl: setControl,
      theme: themes.lincoln
    }, {
      children: _jsxs("div", __assign({
        "data-testid": 'timeout-modal-content'
      }, {
        children: [_jsx("p", {
          children: "Your session is about to timeout in ".concat(sRemaining, " seconds.")
        }), _jsx("p", {
          children: "Click continue to remain logged in."
        })]
      }))
    }))
  });
};
export default /*#__PURE__*/memo(TimeoutModal);